import { createRootRoute, Outlet, useRouterState } from "@tanstack/react-router";
import { ForumShell } from "@/components/forum-shell";

export const Route = createRootRoute({
  component: RootLayout,
});

const AUTH_PATHS = new Set(["/login", "/forgot", "/invite"]);

function RootLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  if (AUTH_PATHS.has(pathname)) {
    return <Outlet />;
  }
  return (
    <ForumShell>
      <Outlet />
    </ForumShell>
  );
}
